module.exports = __webpack_public_path__ + "img/jshengbing.7d059878.gif";